// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4722":"3aa68eb8","5286":"f7c830e4","6533":"6275adc6","7299":"abeac520"}[chunkId] + ".chunk.css";
};